<template>
  <list-list title="Recently Modified Lists" :lists="lists">
    <template #footer>
      <v-pagination
        class="mx-auto"
        :length="Math.ceil(count/pageSize)"
        :total-visible="12"
        :value="page"
        @input="loadPage"
      />
    </template>
  </list-list>
</template>

<script>
import ListList from "@/components/lists/ListList"

export default {
  name: "RecentLists",
  components: {
    ListList,
  },
  data() {
    return {
      lists: [],
      count: 0,
      page: 0,
    }
  },
  inject: ["httpClient"],
  mounted() {
    this.loadPage(1)
  },
  computed: {
    pageSize() {
      return 10
    },
  },
  methods: {
    async loadPage(page) {
      const data = await this.httpClient.loadLists({page})
      this.lists = data.results
      this.page = data.page
      this.count = data.count
    },
  },
}
</script>
